import { UserAdapter } from '@core/adapters';
import { SignUpMemberPayload } from '@core/dto';

export class SignUpMemberUsecase {
  constructor(private readonly UserAdapter: UserAdapter) {
    this.UserAdapter = UserAdapter;
  }

  async execute(payload: SignUpMemberPayload): Promise<any> {
    return await this.UserAdapter.signUpMember(payload);
  }
}
